import { useRef, useState } from "react";
import { TextField, Button, Paper, Typography } from "@material-ui/core";
import axios from "axios";
import { axiosResponse, irahaUser } from "../Gfunc";

export default function LoginIraha({ param = {}, callBack }) {
  const [nom, setNom] = useState("");
  const [mdp, setMdp] = useState("");
  const [errorN, setErrorN] = useState(false);
  const [errorM, setErrorM] = useState(false);
  const [loading, setLoading] = useState(false);
  const mdpInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validNom = nom.trim() !== "";
    const validMdp = mdp.trim() !== "";

    setErrorN(!validNom);
    setErrorM(!validMdp);

    if (!validNom || !validMdp) return;

    setLoading(true);
    try {
      const url = param.urlService
        ? param.urlService + "_usr.php?do=logir"
        : "";
      if (!url) {
        alert("URL de service introuvable.");
        return;
      }

      const response = await axios({
        method: "POST",
        url,
        headers: {
          "content-type": "application/json",
          appID: param.appID || "",
          session: localStorage.getItem("token") || "",
        },
        data: JSON.stringify({ login: nom, password: mdp }),
        timeout: 10000,
      });

      if (!response || typeof response.data !== "object") {
        alert("Réponse serveur invalide.");
        return;
      }

      if (response.data.err) {
        alert(response.data.err);
        return;
      }

      try {
        axiosResponse(response, () => {
          const jData = response.data.jData || {};

          try {
            irahaUser.sesIrh = jData.session || "";
            irahaUser.nomIrh = jData.subuser
              ? jData.subuser.nom || ""
              : jData.nom || "";
            irahaUser.magIrh = jData.mag || "";
            irahaUser.idsubIrh = jData.subuser?.id_isubuser || "";
            localStorage.setItem("irhAcc", JSON.stringify(irahaUser));
          } catch (storageErr) {
            console.warn("Erreur localStorage:", storageErr);
          }
          if (typeof callBack === "function") callBack();
        });
      } catch (innerErr) {
        console.error("Erreur traitement réponse:", innerErr);
        alert("Une erreur interne est survenue.");
      }
    } catch (error) {
      console.error("Erreur requête login:", error);
      alert("Erreur de connexion au serveur.");
    } finally {
      setLoading(false);
      setMdp("");
      if (mdpInputRef?.current) mdpInputRef.current.focus();
    }
  };

  return (
    <Paper
      style={{
        padding: 24,
        maxWidth: 320,
        margin: "6px auto",
        justifyContent: "center",
        textAlign: "center",
      }}
      elevation={3}
    >
      {param.appLoginImg && (
        <img
          src={param.appLoginImg}
          alt="logo"
          height={60}
          width="auto"
          style={{ marginBottom: 16 }}
        />
      )}

      <Typography variant="body2" style={{ fontWeight: 600 }} gutterBottom>
        Connectez-vous à votre compte
      </Typography>

      <form onSubmit={handleSubmit} autoComplete="off" noValidate>
        {/* Prevent browser autofill */}
        <input
          type="text"
          name="fakeusernameremembered"
          style={{ display: "none" }}
          autoComplete="off"
        />
        <input
          type="password"
          name="fakepasswordremembered"
          style={{ display: "none" }}
          autoComplete="new-password"
        />

        <TextField
          error={errorN}
          helperText={errorN ? "Veuillez entrer un nom d'utilisateur" : null}
          label="Nom d'utilisateur"
          id="usrNomIrh"
          name="usrNomIrh"
          value={nom}
          className="smallText"
          margin="dense"
          variant="outlined"
          autoFocus
          fullWidth
          autoComplete="off"
          onChange={(e) => {
            setNom(e.target.value);
            setErrorN(false);
          }}
          required
        />

        <TextField
          inputRef={mdpInputRef}
          error={errorM}
          helperText={errorM ? "Veuillez entrer un mot de passe" : null}
          label="Mot de passe"
          id="usrMdpIrh"
          name="usrMdpIrh"
          type="password"
          value={mdp}
          className="smallText"
          margin="dense"
          variant="outlined"
          fullWidth
          autoComplete="new-password"
          onChange={(e) => {
            setMdp(e.target.value);
            setErrorM(false);
          }}
          required
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          style={{ marginTop: 16 }}
          disabled={loading}
        >
          {loading ? "Connexion..." : "Login"}
        </Button>
      </form>
    </Paper>
  );
}
